import styled, { css } from 'styled-components';

// awesome styled grid
import { Col } from '@zillow/zrs-comet';

export const StyledCol = styled(Col)`
    padding-bottom: ${props => props.theme.ns().spacing.md()};

    /* 768 */
    ${props => props.theme.ns().media.getMediaQuery(`(min-width: ${props.theme.ns().media.BREAKPOINTS.lg - 1}px)`, css`
        padding-bottom: ${props.theme.ns().spacing.sm()};
    `)};

    /* 1440 */
    ${props => props.theme.ns().media.getMediaQuery('(min-width: 1440px)', css`
        padding-bottom: ${props.theme.ns().spacing.md()};
    `)};
`;
